import { FC, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, matchPath } from "react-router-dom";

import GuestTopHeader from "src/components/guestTopHeader";
import HubHeader from '../components/header';
import HubFooter from "../components/footer";
import TawkToMessengerComp from "src/components/tawk.to";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, ManufacturerRoutes, PublicRoutes } from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import ImportantNoticeModal from "src/components/modals/importantNoticeModal";
import { checkCookie } from "src/helpers";
import UpdatedBAAModal from "src/components/modals/updatedBAAModal";


// Higher Order Component function
const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  const [mountTawk, updateMount] = useState<boolean>(false);
  const [importantNoticeModal, changeImportantNoticeModalVisibility] = useState<boolean>(false)
  const [baaContentModal, changeBaaContentModalVisibility] = useState<boolean>(false)

  const { isUserAuthorized, isManufacturer, userData, isRestoreCalled, defaultView: landingPage, new_baa_user_1_2, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const navigateAccordingToUserType = () => {
    if (userData) {
      if (userData.ref_type === "area_manager") {
        navigate(`/areas/${userData.id}?id=${userData.id}&type=areas&role=area_manager`);
      }else if (userData.ref_type === "fad") {
        navigate(landingPage.includes("/") ? landingPage : `/${landingPage}`);
      }
       else if (userData.ref_type === "regional_manager") {
        navigate(`/regions/${userData.id}?id=${userData.id}&type=regions&role=regional_manager`)
      } else if (userData.ref_type === "district_manager" || userData.ref_type === "fad") {
        navigate(`/district/${userData.id}?id=${userData.id}&type=district&role=${userData.ref_type})`)
      } else if (userData.ref_type === "rep") {
       /// navigate(`/territories/${userData.id}?id=${userData.id}&role=rep&type=territories`)
      navigate(`/${"patient_statistics"}?id=${userData.id}&role=${userData.ref_type}`, { replace: true });

      } else {
        navigate(landingPage.includes("/") ? landingPage : `/${landingPage}`);
      }
    }
  }

  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    const indexRoute = RouteListing.find((route) => route.isIndex);

    const currentRoute = RouteListing.find((route) =>
      matchPath({ path: route.route, end: false }, pathname)
    );

    if (userData && userData.is_password_changed === false) {
      navigate(`/users/${userData?.id}/edit`)
    } else {
      if (indexRoute) {
        if (currentRoute) {
          if (currentRoute.route === "/statistics") {
            navigateAccordingToUserType();
          } else {
            navigate(pathname+search);
          }
        } else {
          if (landingPage.includes("statistics")) {
            navigateAccordingToUserType();
          } else {
            navigate(landingPage.includes("/") ? landingPage : `/${landingPage}`);
          }
        }
      }
    }
  }

  const checkForAuthentication = () => {
    if (!isUserAuthorized) {
      navigateToTargetedRoute(PublicRoutes);
    } else {
      if (isManufacturer) {
        navigateToTargetedRoute(ManufacturerRoutes);
      } else {
        navigateToTargetedRoute(AuthenticatedRoutes);
      }
    }
  }

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname+search);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoreCalled]);

  useEffect(() => {
    if (isUserAuthorized) {
      if (!isManufacturer) {
        updateMount(true);

        if (!checkCookie("noothervisited")) {
          changeImportantNoticeModalVisibility(true)
          const nextDay = new Date(new Date().getTime());
          nextDay.setDate(nextDay.getDate() + 1);
          const expires = nextDay;
          document.cookie = `noothervisited=true;expires=${expires.toUTCString()}`;
        }

        if (new_baa_user_1_2) {
          if (!checkCookie("newbaa12visited")) {
            changeBaaContentModalVisibility(true)
            const nextDay = new Date(new Date().getTime());
            nextDay.setDate(nextDay.getDate() + 1);
            const expires = nextDay;
            document.cookie = `newbaa12visited=true;expires=${expires.toUTCString()}`;
          }
        }
      }
      updateMount(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);

  return (
      <>
        <header className="bg-white sticky-top">
          {!isUserAuthorized ? (
            <GuestTopHeader />
          ) : null}
          <HubHeader />
        </header>
        {/* { <div>{showBanner && !isManufacturer && isUserAuthorized && (
            <div className="alert alert-warning auto-save-banner d-flex align-items-start justify-content-between">
              <div>
                <p className="m-0">
                  Please note: Medicare (FFS) eligibility verification is temporarily unavailable. We are actively working to restore this service as soon as possible. Medicare Advantage, commercial, secondary medical plans, and pharmacy benefit verifications remain available and are not impacted.
                  Please feel free to reach out if any questions or additional support is needed.
                </p>
              </div>
              <button type="button" className="btn bi bi-x-lg fs-5 p-0" onClick={handleCloseBanner}></button>
            </div>
        )}</div> } */}
        <WrappedComponent />
        {mountTawk ? (<TawkToMessengerComp />) : null}
        <HubFooter />
        {importantNoticeModal ? (
          <ImportantNoticeModal isModalVisible={importantNoticeModal} onClose={() => changeImportantNoticeModalVisibility(false)} />
        ) : null}
        {baaContentModal ? (
          <UpdatedBAAModal isModalVisible={baaContentModal} onClose={() => changeBaaContentModalVisibility(false)} />
        ) : null}
      </>
  );
}


export default WithHeaderandFooter;
